<template>
  <modal
    @close="$emit('close')"
    bdrs="0"
    bigCross
    bgc="transparent"
    width="100%"
    height="100%"
    maxHeight="100%"
    max-width="100%"
    dark_theme
    class="modal-slider"
  >

    <div class="wrapper_slider posr" slot="body">

      <div class="slider-picture" id="slider-picture">
        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
          <swiper-slide v-for="slide in images" :key="slide.id">
            <img :src="slide.link_picture" alt="photo-model"/>
          </swiper-slide>
          <div v-show="images.length > 1" class="swiper-pagination white-color fw-bold" slot="pagination"></div>
          <div v-show="images.length > 1" class="swiper-button-prev gallery-top-button-prev" slot="button-prev">
            <i class="icon-arrow-right"></i>
          </div>
          <div v-show="images.length > 1" class="swiper-button-next gallery-top-button-next" slot="button-next">
            <i class="icon-arrow-right"></i>
          </div>
        </swiper>
        <swiper v-show="images.length > 1" :options="swiperOptionThumbs" class="gallery-thumbs d-md-block d-none" ref="swiperThumbs">
          <swiper-slide v-for="slide in images" :key="slide.id">
            <img v-if="images.length > 1" :src="slide.link_picture" alt="photo-model-thumbs"/>
          </swiper-slide>
        </swiper>
      </div>
    </div>

  </modal>
</template>

<script>

// Swiper
// https://surmon-china.github.io/vue-awesome-swiper/
// import "swiper/dist/css/swiper.css";
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

// Модалка
import modal from '../../athoms/Modal'

// import { setTimeout } from "timers";
export default {
  components: { modal, Swiper, SwiperSlide },
  props: {
    images: {
      type: Array,
      required: true,
    },
    indexClickedSlide: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      swiperOptionTop: {
        spaceBetween: 10,
        // slidesPerView: 1,
        // centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
      },
      swiperOptionThumbs: {
        spaceBetween: 32,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop

      swiperTop.slideTo(this.indexClickedSlide, 0)
      swiperThumbs.slideTo(this.indexClickedSlide, 0)
    })
  },
  methods: {
    closeModal () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.modal-slider {
  padding: 10px 0;
}

.wrapper_slider {
  // height: 100vh;
}

// Блок-обертка для всех слайдеров
.slider-picture {
  // max-width: 684px;
  // max-height: 601px;
}

// Верхний слайдер
.gallery-top {
  padding-bottom : 69px;
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    height         : 100vh;
    display        : flex;
    align-items    : center;
    padding-bottom : 0;
  }
}

// Стили для всех слайдов
.swiper-slide {
  display         : flex;
  justify-content : center;

  img {
    box-sizing       : border-box;
    border-radius    : 5px;
    background-color : $bg-main;
    max-width        : 100%;
    object-fit       : contain;
  }
}

// Основной слайд (верхний)
.gallery-top .swiper-slide {
  height: 100%; // for unsupported browsers
  height: calc(100vh - 176px);

  img {
    width   : auto;
    padding : 24px;
    height: auto;

    // 69px паддинг слайдера,
    // 87px высота нижнего слайдера,
    // 20px(10px + 10px) паддинг модалки
    max-height: calc(100vh - 176px);
    
    max-width: 100%;
    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
      height  : 300px;
      width   : 300px;
      padding : 16px;
      margin  : 120px auto auto;
    }
  }
}

// Слайд-превью (нижний)
.gallery-thumbs .swiper-slide {
  width      : 87px;
  height     : 87px;
  cursor     : pointer;
  opacity    : 0.5;
  transition : all 0.2s;

  &:hover {
    opacity : 0.75;
  }

  img {
    max-width : 100%;
    width     : 87px;
    height    : 87px;
    padding   : 8px;
  }
}

// Активный слайд-превью
.gallery-thumbs .swiper-slide-active {
  opacity : 1 !important;
}

// Пагинация
.swiper-pagination-fraction {
  bottom : 24px;
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    bottom : unset;
    top    : calc(50% + 205px)
  }
}

// Стрелки навигации
.gallery-top-button-next,
.gallery-top-button-prev {
  $size-btn        : 3.5333rem;
  $margin-btn      : -$size-btn / 2 - 2.3rem;
  display          : flex;
  justify-content  : center;
  align-items      : center;
  width            : $size-btn;
  height           : $size-btn;
  margin-top       : $margin-btn;
  border-radius    : 50%;
  background-color : #c8c8c8;
  box-shadow       : 0.3333rem 0 0.8667rem 0 rgba(0, 0, 0, 0.098);
  // background-size: unset;
  // background-position: unset;
  // background-repeat: unset;

  background-image : none;

  &:after {
    content : '';
  }

  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    top : calc(50% + 246px)
  }

  .icon-arrow-right {
    font-size               : 20px;
    color                   : #656565;
    -webkit-text-fill-color : #656565;
  }

  &:hover {
    box-shadow       : 0.6667rem 0 1.3333rem 0 rgba(0, 0, 0, 0.098);
    background-color : $bg-main;

    .icon-arrow-right {
      color                   : $active;
      -webkit-text-fill-color : $active;
    }
  }

  &:active {
    box-shadow       : 0 0 0.3333rem 0 rgba(0, 0, 0, 0.098);
    background-color : #f8f8f8;
  }
}

// Левая кнопка
.gallery-top-button-prev {
  left : 18px;
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    left : 10px;
  }

  .icon-arrow-right {
    transform : rotate(180deg);
  }
}

// Правая кнопка
.gallery-top-button-next {
  right : 18px;
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    right : 10px;
  }
}

// Отключенные кнопки
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity        : 0.4;
  cursor         : auto;
  pointer-events : none;
}
</style>
